import { FC } from 'react';
import { Center, Controls, Footer, Header, Layout, Left, Main, MainLayout, Right } from '../Components/Layout';
import styled from 'styled-components';
// @ts-ignore
import Logo from 'url:../Assets/logo.png';

const MobileCompatibleMainLayout = styled(MainLayout).attrs((p) => ({
  ...p,
  className: 'mobile-compatible-main-layout',
}))`
  &.mobile-compatible-main-layout {
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr 3fr 1fr;
    }
  }
`;
const LogoImg = styled.img.attrs({
  src: Logo,
  className: 'logo-img',
})`
  &.logo-img {
    width: 10em;
  }
`;
const LoginCenter = styled(Center)`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3em;
`;

export type LoginProps = {
  onSignIn: () => void;
  goToDocumentAcceptance: () => void;
};

export const Login: FC<LoginProps> = ({ onSignIn, goToDocumentAcceptance }) => (
  <Layout>
    <Header />
    <Main>
      <MobileCompatibleMainLayout>
        <Left />
        <LoginCenter>
          <LogoImg />
          <Controls>
            <button onClick={onSignIn}>Sign In</button>
            <button onClick={goToDocumentAcceptance}>Sign Up</button>
          </Controls>
        </LoginCenter>
        <Right />
      </MobileCompatibleMainLayout>
    </Main>
    <Footer />
  </Layout>
);
